import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, startSubmit } from 'redux-form';

import { EMPLOYEE_FORM } from 'src/constants/FormNames';

import { getItemErrors, setItem } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, newEmployee } from 'src/reducers/employees/employees';
import { getSelectOptions } from 'src/reducers/selectOptions';

import AnyJobRunning from './components/AnyJobRunning';
import AnyApiRunning from './components/AnyApiRunning';
import EmployeeCreatingForm from './components/EmployeeCreatingForm';
import { useTranslation } from 'react-i18next';
import { isTutorialStep3Running } from '../../utils/Tutorial';

const mapStateToProps = state => ({
  isNewForm: true,
  isTutorialRunning: isTutorialStep3Running(),
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: { ...(state.employees.item.data || {}), baseSalary: 0 }
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(startSubmit(EMPLOYEE_FORM));
    dispatch(newEmployee(data));
  }
});

const NewEmployeeForm = connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: EMPLOYEE_FORM
  })(EmployeeCreatingForm)
);

const NewEmployee = ({ anyJobRunning, anyApiRunning, dispatch, employee }) => {
  dispatch(setItem(REDUCER_NAME, employee));
  const { t } = useTranslation();

  return (
    <div>
      {anyJobRunning && <AnyJobRunning />}
      {anyApiRunning && <AnyApiRunning />}
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.Employees.NewEmployee.Register_employee_information')}</h1>
      </div>
      <NewEmployeeForm {...{ anyJobRunning, anyApiRunning }} />
    </div>
  );
};
export default connect(state => ({
  anyJobRunning: getSelectOptions(state, 'anyJobRunning'),
  anyApiRunning: getSelectOptions(state, 'anyApiRunning')
}))(NewEmployee);
